import {UnpaidLeaveLimits} from './vacation.models';
import {UNPAID_LIMIT_MAX, UNPAID_LIMIT_MIN} from './unpaid-leave.constants';

export function unpaidLimitsConfigured(policy: UnpaidLeaveLimits): boolean {
  return unpaidValues(policy).some(value => value !== null && value !== undefined);
}

export function unpaidLimitsValid(policy: UnpaidLeaveLimits): boolean {
  return !unpaidLimitsConfigured(policy) || unpaidValues(policy).every(value =>
    typeof value === NUMBER_TYPE && isFinite(value) && Math.floor(value) === value &&
    value >= UNPAID_LIMIT_MIN && value <= UNPAID_LIMIT_MAX);
}

const NUMBER_TYPE = 'number';

function unpaidValues(policy: UnpaidLeaveLimits): number[] {
  return [policy.unpaidSingleDayLimit, policy.unpaidMultiDayLimit, policy.unpaidMonthlyDayLimit];
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/vacation/unpaid-leave-policy.ts